import type { PropsWithChildren, ReactNode } from 'react';

import { useOnboardingSurvey } from '../../hooks/useOnboardingSurvey';
import { OnboardingSurvey } from '../OnboardingSurvey';

type OnboardingSurveyGateProps = PropsWithChildren<{ fallback?: ReactNode }>;

export const OnboardingSurveyGate = ({
  children,
  fallback = null,
}: OnboardingSurveyGateProps) => {
  const { status, workspaceName, isSaving, hasSaveError, saveAnswers } =
    useOnboardingSurvey();

  if (status === 'loading') {
    return <>{fallback}</>;
  }

  if (status === 'unanswered') {
    return (
      <OnboardingSurvey
        workspaceName={workspaceName}
        isSaving={isSaving}
        hasSaveError={hasSaveError}
        onSave={saveAnswers}
      />
    );
  }

  return <>{children}</>;
};
